import React from "react"
import formatDate from "../../../../../../gd/format/date";
import DatetimeUtils from "../../../../../../gd/utils/datetime-utils";
import {FieldEditableMode, FieldEditableProps, FieldEditableState} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldStatus_TableCell"
const debug = false


export default class FieldDate_Editable extends React.Component<FieldEditableProps, FieldEditableState> {

    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            mode        : FieldEditableMode.VIEW
        }
    }

    get canEdit():boolean {
        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) {
            return false
        }
        return true
    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) this.setState({
            mode   : FieldEditableMode.HOVERED
        })
    }

    onMouseLeave = () => {
        if (this.state.mode === FieldEditableMode.HOVERED) {
            this.setState({
                mode        : FieldEditableMode.VIEW
            })
        }
    }

    async onValueChange(value: Moment|null, hidePopover:boolean=true) {

        // make it first (!) to update model and hidePopover will reRenbder(!)
        this.props.onChange && this.props.onChange(value)

        hidePopover && this.hidePopover()
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        if(this.state.mode === FieldEditableMode.EDITING){
            this.setState({
                mode     : FieldEditableMode.HOVERED
            })
        }
        else{
            this.setState({
                mode     : FieldEditableMode.EDITING
            })
        }
    }

    onOptionClick = (option:Option) => {
        this.onValueChange(option.value as Moment|null)
    }

    hidePopover = () => {
        this.setState({
            mode        : FieldEditableMode.VIEW
        })
    }

    renderValue() {

        let value     = this.props.field.getViewValue(this.props.model)

        if (!value) return null

        // "w-100-percent", "flex-row-left-center",
        const classes   = Classes("txt-truncate cursor-default", {
            'ui5-color-red'         : this.props.field.fieldParams.highlightIfPastdue && DatetimeUtils.isBeforeToday(value),
        })

        return (
            <div className={classes}>
                {formatDate(DatetimeUtils.dateToMoment(value))}
            </div>
        );
    }

    renderEditing() {
        const currentValue  = DatetimeUtils.dateToMoment(this.props.field.getViewValue(this.props.model))

        const classes = Classes(this.classes, "is-hovered")
        const showReset = this.props.field.clearButton && !!currentValue

        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick} >
                    {this.renderValue()}

                    {!currentValue &&
                        <div className="ui5-txt-no-accent-default flex-row-left-center txt-truncate cursor-default">
                            {this.props.field.placeholder}
                        </div>}

                    <div className="buttons flex-no-shrink">
                        {showReset &&
                            <div className  = "btn-reset"
                                 onClick    = {this.onDeleteClick}
                            />}
                        <div className="btn-arrow"/>
                    </div>
                </div>
                <this.props.field.components.PopoverMenu
                    parent={this}
                    field={this.props.field}
                    value={currentValue}
                    // listItem={this.props.listItem}
                    // manager={this.props.manager}
                />
            </React.Fragment>
        )
    }

    renderHovered() {
        const currentValue  = this.props.field.getViewValue(this.props.model)

        const classes = Classes(this.classes, "is-hovered")
        const showReset = this.props.field.clearButton && !!currentValue

        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
                {!currentValue &&
                    <div className="ui5-txt-no-accent-default w-100-percent flex-row-left-center txt-truncate">
                        {this.props.field.placeholder}
                    </div>}

                <div className="buttons flex-no-shrink">
                    {showReset &&
                        <div className  = "btn-reset"
                             onClick    = {this.onDeleteClick}
                        />}
                    <div className="btn-arrow"/>
                </div>
            </div>
        )
    }

    renderView() {

        return (
            <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
            </div>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.mode)


        switch (this.state.mode) {

            case FieldEditableMode.EDITING:
                return this.renderEditing()

            case FieldEditableMode.HOVERED:
                return this.renderHovered()

            default:
            case FieldEditableMode.VIEW:
                return this.renderView()
        }

    }
}



